<script setup lang="ts">
import CreateBankAccount from "@/user/components/CreateBankAccount.vue";
import BaseModal from '@/application/components/BaseModal.vue';
import type { MinimumBankAccount } from '@/api/bankAccount/types.ts';

defineProps<{ show: boolean, initData?: MinimumBankAccount }>();
const emit = defineEmits(['update:show']);
</script>

<template>
  <BaseModal
    :show="show"
    title="Bankverbindung anlegen"
    height="85%"
    @close="emit('update:show', false)"
  >
    <CreateBankAccount
      v-if="show"
      :init-data="initData"
      @close="emit('update:show', false)"
    />
  </BaseModal>
</template>
